"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "APIError", {
  enumerable: true,
  get: function get() {
    return _APIError.default;
  }
});
Object.defineProperty(exports, "Cursor", {
  enumerable: true,
  get: function get() {
    return _Cursor.default;
  }
});
Object.defineProperty(exports, "CURSOR_COMPATIBILITY_SYMBOL", {
  enumerable: true,
  get: function get() {
    return _Cursor.CURSOR_COMPATIBILITY_SYMBOL;
  }
});
Object.defineProperty(exports, "EditorialWorkflowError", {
  enumerable: true,
  get: function get() {
    return _EditorialWorkflowError.default;
  }
});
Object.defineProperty(exports, "EDITORIAL_WORKFLOW_ERROR", {
  enumerable: true,
  get: function get() {
    return _EditorialWorkflowError.EDITORIAL_WORKFLOW_ERROR;
  }
});
Object.defineProperty(exports, "localForage", {
  enumerable: true,
  get: function get() {
    return _localForage.default;
  }
});
Object.defineProperty(exports, "isAbsolutePath", {
  enumerable: true,
  get: function get() {
    return _path.isAbsolutePath;
  }
});
Object.defineProperty(exports, "basename", {
  enumerable: true,
  get: function get() {
    return _path.basename;
  }
});
Object.defineProperty(exports, "fileExtensionWithSeparator", {
  enumerable: true,
  get: function get() {
    return _path.fileExtensionWithSeparator;
  }
});
Object.defineProperty(exports, "fileExtension", {
  enumerable: true,
  get: function get() {
    return _path.fileExtension;
  }
});
Object.defineProperty(exports, "onlySuccessfulPromises", {
  enumerable: true,
  get: function get() {
    return _promise.onlySuccessfulPromises;
  }
});
Object.defineProperty(exports, "flowAsync", {
  enumerable: true,
  get: function get() {
    return _promise.flowAsync;
  }
});
Object.defineProperty(exports, "then", {
  enumerable: true,
  get: function get() {
    return _promise.then;
  }
});
Object.defineProperty(exports, "unsentRequest", {
  enumerable: true,
  get: function get() {
    return _unsentRequest.default;
  }
});
Object.defineProperty(exports, "filterByPropExtension", {
  enumerable: true,
  get: function get() {
    return _backendUtil.filterByPropExtension;
  }
});
Object.defineProperty(exports, "getAllResponses", {
  enumerable: true,
  get: function get() {
    return _backendUtil.getAllResponses;
  }
});
Object.defineProperty(exports, "parseLinkHeader", {
  enumerable: true,
  get: function get() {
    return _backendUtil.parseLinkHeader;
  }
});
Object.defineProperty(exports, "parseResponse", {
  enumerable: true,
  get: function get() {
    return _backendUtil.parseResponse;
  }
});
Object.defineProperty(exports, "responseParser", {
  enumerable: true,
  get: function get() {
    return _backendUtil.responseParser;
  }
});
Object.defineProperty(exports, "getPathDepth", {
  enumerable: true,
  get: function get() {
    return _backendUtil.getPathDepth;
  }
});
Object.defineProperty(exports, "loadScript", {
  enumerable: true,
  get: function get() {
    return _loadScript.default;
  }
});
Object.defineProperty(exports, "getBlobSHA", {
  enumerable: true,
  get: function get() {
    return _getBlobSHA.default;
  }
});
Object.defineProperty(exports, "asyncLock", {
  enumerable: true,
  get: function get() {
    return _asyncLock.asyncLock;
  }
});
Object.defineProperty(exports, "entriesByFiles", {
  enumerable: true,
  get: function get() {
    return _implementation.entriesByFiles;
  }
});
Object.defineProperty(exports, "entriesByFolder", {
  enumerable: true,
  get: function get() {
    return _implementation.entriesByFolder;
  }
});
Object.defineProperty(exports, "unpublishedEntries", {
  enumerable: true,
  get: function get() {
    return _implementation.unpublishedEntries;
  }
});
Object.defineProperty(exports, "getMediaDisplayURL", {
  enumerable: true,
  get: function get() {
    return _implementation.getMediaDisplayURL;
  }
});
Object.defineProperty(exports, "getMediaAsBlob", {
  enumerable: true,
  get: function get() {
    return _implementation.getMediaAsBlob;
  }
});
Object.defineProperty(exports, "runWithLock", {
  enumerable: true,
  get: function get() {
    return _implementation.runWithLock;
  }
});
Object.defineProperty(exports, "readFile", {
  enumerable: true,
  get: function get() {
    return _API.readFile;
  }
});
Object.defineProperty(exports, "CMS_BRANCH_PREFIX", {
  enumerable: true,
  get: function get() {
    return _API.CMS_BRANCH_PREFIX;
  }
});
Object.defineProperty(exports, "generateContentKey", {
  enumerable: true,
  get: function get() {
    return _API.generateContentKey;
  }
});
Object.defineProperty(exports, "isCMSLabel", {
  enumerable: true,
  get: function get() {
    return _API.isCMSLabel;
  }
});
Object.defineProperty(exports, "labelToStatus", {
  enumerable: true,
  get: function get() {
    return _API.labelToStatus;
  }
});
Object.defineProperty(exports, "statusToLabel", {
  enumerable: true,
  get: function get() {
    return _API.statusToLabel;
  }
});
Object.defineProperty(exports, "DEFAULT_PR_BODY", {
  enumerable: true,
  get: function get() {
    return _API.DEFAULT_PR_BODY;
  }
});
Object.defineProperty(exports, "MERGE_COMMIT_MESSAGE", {
  enumerable: true,
  get: function get() {
    return _API.MERGE_COMMIT_MESSAGE;
  }
});
Object.defineProperty(exports, "isPreviewContext", {
  enumerable: true,
  get: function get() {
    return _API.isPreviewContext;
  }
});
Object.defineProperty(exports, "getPreviewStatus", {
  enumerable: true,
  get: function get() {
    return _API.getPreviewStatus;
  }
});
Object.defineProperty(exports, "PreviewState", {
  enumerable: true,
  get: function get() {
    return _API.PreviewState;
  }
});
Object.defineProperty(exports, "parseContentKey", {
  enumerable: true,
  get: function get() {
    return _API.parseContentKey;
  }
});
exports.NetlifyCmsLibUtil = void 0;

var _APIError = _interopRequireDefault(require("./APIError"));

var _Cursor = _interopRequireWildcard(require("./Cursor"));

var _EditorialWorkflowError = _interopRequireWildcard(require("./EditorialWorkflowError"));

var _localForage = _interopRequireDefault(require("./localForage"));

var _path = require("./path");

var _promise = require("./promise");

var _unsentRequest = _interopRequireDefault(require("./unsentRequest"));

var _backendUtil = require("./backendUtil");

var _loadScript = _interopRequireDefault(require("./loadScript"));

var _getBlobSHA = _interopRequireDefault(require("./getBlobSHA"));

var _asyncLock = require("./asyncLock");

var _implementation = require("./implementation");

var _API = require("./API");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const NetlifyCmsLibUtil = {
  APIError: _APIError.default,
  Cursor: _Cursor.default,
  CURSOR_COMPATIBILITY_SYMBOL: _Cursor.CURSOR_COMPATIBILITY_SYMBOL,
  EditorialWorkflowError: _EditorialWorkflowError.default,
  EDITORIAL_WORKFLOW_ERROR: _EditorialWorkflowError.EDITORIAL_WORKFLOW_ERROR,
  localForage: _localForage.default,
  basename: _path.basename,
  fileExtensionWithSeparator: _path.fileExtensionWithSeparator,
  fileExtension: _path.fileExtension,
  onlySuccessfulPromises: _promise.onlySuccessfulPromises,
  flowAsync: _promise.flowAsync,
  then: _promise.then,
  unsentRequest: _unsentRequest.default,
  filterByPropExtension: _backendUtil.filterByPropExtension,
  parseLinkHeader: _backendUtil.parseLinkHeader,
  parseResponse: _backendUtil.parseResponse,
  responseParser: _backendUtil.responseParser,
  loadScript: _loadScript.default,
  getBlobSHA: _getBlobSHA.default,
  getPathDepth: _backendUtil.getPathDepth,
  entriesByFiles: _implementation.entriesByFiles,
  entriesByFolder: _implementation.entriesByFolder,
  unpublishedEntries: _implementation.unpublishedEntries,
  getMediaDisplayURL: _implementation.getMediaDisplayURL,
  getMediaAsBlob: _implementation.getMediaAsBlob,
  readFile: _API.readFile,
  CMS_BRANCH_PREFIX: _API.CMS_BRANCH_PREFIX,
  generateContentKey: _API.generateContentKey,
  isCMSLabel: _API.isCMSLabel,
  labelToStatus: _API.labelToStatus,
  statusToLabel: _API.statusToLabel,
  DEFAULT_PR_BODY: _API.DEFAULT_PR_BODY,
  MERGE_COMMIT_MESSAGE: _API.MERGE_COMMIT_MESSAGE,
  isPreviewContext: _API.isPreviewContext,
  getPreviewStatus: _API.getPreviewStatus,
  runWithLock: _implementation.runWithLock,
  PreviewState: _API.PreviewState,
  parseContentKey: _API.parseContentKey
};
exports.NetlifyCmsLibUtil = NetlifyCmsLibUtil;